import { RiErrorWarningFill } from "react-icons/ri";

const WarningPopup = ({ title = "Notice", message, onClose }) => {
  if (!message) return null;

  return (
    <div className="inset-0 z-50 bg-black bg-opacity-40 flex items-center justify-center absolute">
      <div className="bg-white w-full max-w-sm mx-4 rounded-2xl shadow-xl p-6 relative text-center">
        <div className="flex justify-center mb-3">
          <RiErrorWarningFill className="text-4xl text-yellow-500" />
        </div>
        <h3 className="text-lg font-semibold text-secondary mb-2">{title}</h3>
        <p className="text-sm text-gray-600 mb-6">{message}</p>
        <button
          className="px-6 py-2 rounded-lg bg-primary hover:bg-green-600 text-white text-sm"
          onClick={onClose}
        >
          OK
        </button>
      </div>
    </div>
  );
};

export default WarningPopup;
